import { Injectable } from "@angular/core";
import { Observable, of, Subject, Subscription } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { EstatusJSON } from "../../shared/models/EstatusJSON";
import { CatalogPaginationRequest } from "../../shared/models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../shared/models/Filter/FilterRequest";
import { ActiveAlarmsPopupComponent } from "../../alarms/components/active-alarms-popup/active-alarms-popup.component";
import { NotificationDTO } from "../models/NotificationDTO";
import { MiniMapService } from "../../shared/services/MiniMap.service";
import { NotificationsAPIService } from "../../shared/services/API/NotificationsAPI.service";

@Injectable({
  providedIn: "root",
})
export class NotificationService {

  public isConfirmed: boolean = false;
public showNavNotifications: boolean = false;
public navNotificationCount: number = 0;

notificationList: NotificationDTO[] = [];
isLoadingNotificationes: boolean;
isNotificationEnd: boolean = false;

private activeNotificationCount$ : Subject<number> = new Subject();
  private notificationList$ : Subject<NotificationDTO[]> = new Subject();

public catalogFilterModule = 'NotificationCatalog';

  subscription_GetNotifications: Subscription;
  subscription_GetActiveNotificationsCount: Subscription;
  subscription_DeactivateWebNotifications: Subscription;


constructor(
  private miniMapService: MiniMapService,
  private dialog: MatDialog,
  private notificationService: NotificationsAPIService) {
}

  //nav notifications

  toggleNotifications(){
    // solo se manda la señal para desactivar las notificaciones si hay notificaciones activas y no se ha mandado la señal
    if (this.navNotificationCount > 0 ) {
      var countHolder = this.navNotificationCount;
      this.setNotificationCount(0);
    }

    this.showNavNotifications = !this.showNavNotifications;
  }

  setNotificationCount(activeNotificationCount: number) {
    if(activeNotificationCount > 0)
      this.isNotificationEnd = false;
    this.navNotificationCount = activeNotificationCount;
  }

  getActiveNotificationsCount() {
    this.subscription_GetActiveNotificationsCount = this.GetNotificationsActiveCount().subscribe((data) => {
      if (data.isSuccess) {
        this.setNotificationCount(data.result);
      }
    });
  }

  getNotificationList() {
    return this.notificationList$.asObservable();
  }

  setNotificationList(notificationList: NotificationDTO[]) {
    this.notificationList = notificationList;
    this.notificationList$.next(notificationList);
    this.isLoadingNotificationes = false;
  }

  addNotificationToList(notification: NotificationDTO) {
    this.notificationList.push(notification);
    this.notificationList$.next(this.notificationList);
  }

  addNotificationListToList(notificationList: NotificationDTO[]) {
    // se añaden los elementos de la lista de notificaciones obtenidas a la lista de notificaciones actual con set para evitar duplicados
    this.notificationList = Array.from(new Set(this.notificationList.concat(notificationList)));
    this.notificationList$.next(this.notificationList);
    this.isLoadingNotificationes = false;
  }

  getNotifications(page : number) {
    if(this.isNotificationEnd){
      return;
    }

    this.isLoadingNotificationes = true;
    this.subscription_GetNotifications = this.GetWebWithoutStatusPage(page).subscribe((data) => {
      if (data.isSuccess) {
        // si ya no hay datos, se termina la busqueda
        if (data.result.length == 0) {
          this.isNotificationEnd = true;
          this.subscription_GetNotifications.unsubscribe();
          var empty = new Array<NotificationDTO>();
          this.setNotificationPage(empty, page);
          return;
        }

        // si hay menos de 10 elementos, se asignan los que hay y termina la busqueda
        if (data.result.length < 10) {
          this.isNotificationEnd = true;
          this.subscription_GetNotifications.unsubscribe();
          this.setNotificationPage(data.result, page);
          return;
        }

        this.setNotificationPage(data.result, page);
      }
    });
  }

  setNotificationPage(result: any, page: number) {
    if(page == 1)
      this.setNotificationList(result);

    if(page != 1)
      this.addNotificationListToList(result);
  }


  NavBarNotificationClick(idAlarm: number, idNotification: number){
    console.log('alarm event', event);
    const dialogRef = this.dialog.open(ActiveAlarmsPopupComponent, {
      width: "auto",
      height: "fit-content",
      autoFocus: false,
      restoreFocus: false,
      data: {id: idAlarm}
    });

    dialogRef.afterClosed().subscribe(reload => {
      console.log('cerrado');
      this.miniMapService.deleteMap();
      this.notificationList.find(x => x.id = idNotification).isReaded = true;
      this.subscription_DeactivateWebNotifications = this.DeactivateWebNotificationById(idNotification).subscribe((data) => {
        if (data.isSuccess) {
            this.subscription_DeactivateWebNotifications.unsubscribe();
        }
      });
    });
  }


  GetWebWithoutStatusPage(page: number): any {
    return this.notificationService.GetWebWithoutStatusPage(page);
  }
  
  GetNotificationsActiveCount(): any {
    return this.notificationService.GetNotificationsActiveCount();
  }
  
  DeactivateWebNotifications(): any {
    return this.notificationService.DeactivateWebNotifications();
  }
  
  DeactivateWebNotificationById(id: number): any {
    return this.notificationService.DeactivateWebNotificationById(id);
  }

  //paginacion
    getFilterValues(request : FilterRequest[]): any {
      return this.notificationService.getFilterValues(request);
    }
  
    getPage(request : CatalogPaginationRequest): any {
      return this.notificationService.getPage(request);
    }
  
    getCount(request : CatalogPaginationRequest): any {
      return this.notificationService.getCount(request);
    }
  
}
